import React, { useMemo } from 'react';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { useLayout, useScroll } from '../../../../utils/useLayout';
import ModalComponent from '../../../../components/atoms/ModalComponent';
import Button from '../../widgets/Button/Button';
import Styles from './ModalApartamento.css';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import clsx from 'clsx';

function ModalApartamento() {
  const {
    modalApartmentOpen,
    setModalApartmentOpen,
    setResidencyType,
    setSimulationStep,
    isMobile,
  } = useSimuladorEnergiaSolarState();

  const { scrollToTop } = useScroll();
  const { height } = useLayout(!modalApartmentOpen);

  const scrollable = height !== 0 && height < (isMobile ? 650 : 602) + 8 * 2;

  return (
    <>
      <ModalComponent
        id="modal-apartment"
        open={modalApartmentOpen}
        setOpen={setModalApartmentOpen}
        disableSurface
        className={clsx({
          'enabled-scroll': scrollable,
        })}
      >
        <div className="modal-apartment">
          <img
            className="logo"
            src="assets/simulador-energia-solar/jornada/apartment-logo.svg"
            alt=""
          />
          <h6 className="title">
            {isMobile ? (
              <>
                Seu apartamento
                <br /> com energia solar!
              </>
            ) : (
              <>Seu apartamento com energia solar!</>
            )}
          </h6>
          <p className="description">
            {isMobile && (
              <>
                Com nosso parceiro <b>Fitnergia</b>, uma empresa do Santander, você pode garantir
                hoje mesmo o acesso a projetos de energia solar e começar a economizar mês a mês.
              </>
            )}
            {!isMobile && (
              <>
                Com nosso parceiro <b>Fitnergia</b>, uma empresa do Santander, você pode contratar
                um serviço de energia solar e começar a economizar na conta de luz.
              </>
            )}
          </p>

          <Button
            variant="red"
            onClick={(ev) => {
              ev.preventDefault();
              scrollToTop();
              setSimulationStep(SIMULATION_STEPS.END_JOURNEY_APARTMENT);
              setModalApartmentOpen(false);
            }}
          >
            Explorar opções
          </Button>
          <Button
            variant="white"
            onClick={(ev) => {
              ev.preventDefault();
              scrollToTop();
              setModalApartmentOpen(false);
              setResidencyType(null);
            }}
          >
            Voltar
          </Button>
        </div>
      </ModalComponent>

      <style jsx>{Styles}</style>
    </>
  );
}

export default ModalApartamento;
